/**
 * Language selector: IconButton + Menu (Русский / English).
 * Uses project i18n (localStorage "Lan": "EN" | "RU"); syncs with react-i18next.
 */
import * as React from 'react';
import IconButton from '@mui/material/IconButton';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import LanguageRoundedIcon from '@mui/icons-material/LanguageRounded';
import { useTranslation } from 'react-i18next';
import i18n, { resolveAppLanguage } from '../../localization/i18n';

const STORAGE_KEY = 'Lan';

function getStoredLocale() {
  try {
    const v = localStorage.getItem(STORAGE_KEY);
    if (v === 'RU' || v === 'EN') return v;
  } catch {
    /* ignore */
  }
  return resolveAppLanguage() === 'ru' ? 'RU' : 'EN';
}

export default function LanguageIconDropdown(props) {
  const { t } = useTranslation();
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [locale, setLocale] = React.useState(() => getStoredLocale());
  const open = Boolean(anchorEl);

  React.useEffect(() => {
    const stored = getStoredLocale();
    const code = stored === 'RU' ? 'ru' : 'en';
    if (i18n.language !== code && i18n.language !== stored) {
      i18n.changeLanguage(code);
    }
    setLocale(stored);
  }, []);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleLocale = (value) => () => {
    const code = value === 'RU' ? 'ru' : 'en';
    setLocale(value);
    try {
      localStorage.setItem(STORAGE_KEY, value);
      i18n.changeLanguage(code);
    } catch (_) {}
    handleClose();
  };

  return (
    <>
      <IconButton
        data-screenshot="toggle-language"
        onClick={handleClick}
        disableRipple
        size="small"
        aria-controls={open ? 'language-menu' : undefined}
        aria-haspopup="true"
        aria-expanded={open ? 'true' : undefined}
        aria-label={t('dashboard.selectLanguage')}
        {...props}
      >
        <LanguageRoundedIcon />
      </IconButton>
      <Menu
        anchorEl={anchorEl}
        id="language-menu"
        open={open}
        onClose={handleClose}
        onClick={handleClose}
        disableScrollLock
        slotProps={{
          paper: {
            variant: 'outlined',
            elevation: 0,
            sx: { my: '4px', zIndex: 1301 },
          },
        }}
        transformOrigin={{ horizontal: 'right', vertical: 'top' }}
        anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
      >
        <MenuItem selected={locale === 'RU'} onClick={handleLocale('RU')}>
          {t('language.ru')}
        </MenuItem>
        <MenuItem selected={locale === 'EN'} onClick={handleLocale('EN')}>
          {t('language.en')}
        </MenuItem>
      </Menu>
    </>
  );
}
